import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'app-form-modal',
  templateUrl: './form-modal.component.html',
  styleUrls: ['./form-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FormModalComponent implements AfterViewInit {

  constructor(private cdr: ChangeDetectorRef,
              public dialogRef: DialogRef<any>
  ) {
  }

  public onClose(): void {
    this.dialogRef.close();
  }

  ngAfterViewInit(): void {
    this.cdr.detach();
  }
}
